const initRelatedUsageAreasWidget = () => {
    const flickitySlidersArray = initCarousel("[data-related-usage-areas-widget-slider] [data-slider]", cellAlign.left, true, 5000, true, false, false);
    flickitySlidersArray.forEach(flickitySlider => {
        const prevButton = flickitySlider.slider.closest("[data-related-usage-areas-widget-slider]").querySelector("[data-prev-button]");
        //custom binding to prev button
        prevButton.addEventListener("click", () => {
            flickitySlider.previous();
        });
        //custom binding to next button
        const nextButton = flickitySlider.slider.closest("[data-related-usage-areas-widget-slider]").querySelector("[data-next-button]");
        nextButton.addEventListener("click", () => {
            flickitySlider.next();
        });
    });
};
